export type StatusStyleProps = {
    baseColor: string,
    invertColor: string,
    circleColor?: string,
    backgroundColor?: string,
    outlinedColor?: string,
    outlidedTextColor?: string,
    textColor?: string,
}


export enum StatusStyleCode {
    Red = 'red',
    Yellow = 'yellow',
    Green = 'green',
    Blue = 'blue',
    White = 'white',
    Black = 'black',
    Gray = 'gray',
    Unknown = 'unknown',
}

export const StatusStyleDict: { [key in StatusStyleCode]: StatusStyleProps } = {
    [StatusStyleCode.Red]: {
        baseColor: '#cf4343',
        invertColor: '#ffffff',
    },
    [StatusStyleCode.Yellow]: {
        baseColor: '#f1c944',
        invertColor: '#584301',
        backgroundColor: '#fdd250',
        outlinedColor: '#e9bd38',
        outlidedTextColor: '#7c5300',
        textColor: '#af9500',
    },
    [StatusStyleCode.Green]: {
        baseColor: '#41a06e',
        invertColor: '#ffffff',
    },
    [StatusStyleCode.Blue]: {
        baseColor: '#5282bd',
        invertColor: '#ffffff',
        outlinedColor: '#3872b9',
    },
    [StatusStyleCode.White]: {
        baseColor: '#d8d8d8',
        invertColor: '#000000',
        backgroundColor: '#f5f5f5',
        outlinedColor: '#999999',
        outlidedTextColor: '#838383',
    },
    [StatusStyleCode.Black]: {
        baseColor: '#494949',
        invertColor: '#ffffff',
    },
    [StatusStyleCode.Gray]: {
        baseColor: '#808080',
        invertColor: '#ffffff',
        outlidedTextColor: '#777777',
        textColor: '#6e6e6e',
    },
    [StatusStyleCode.Unknown]: {
        baseColor: '#b9a6a6',
        invertColor: '#666666',
    },
}


export enum StatusChipVariant {
    /** Закрашен фон и текст */
    Contained = 'contained',

    /** Рамка и текст*/
    Outlined = 'outlined',

    /** Просто текст */
    Text = 'text',

    /** Иконка и текст */
    WithIcon = 'withIcon',
}
